// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PageHead — page header (kicker + display title + sub + actions). */
.page-head {
  margin-bottom: var(--space-6);
}
.page-head__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  /* The action row does not shrink, so without wrapping it pushes the page past
     the viewport on a narrow screen: 370px of buttons against 312px of content
     area. Wrapping drops the row below the title instead. */
  flex-wrap: wrap;
  /* Reserved title-row height so a short title keeps the detail ladder
     from collapsing (canon: dhead__titlerow). */
  min-height: 46px;
}
.page-head__actions {
  display: flex;
  gap: 8px;
  flex: none;
  align-items: center;
  /* Its own line is still narrower than the two buttons side by side, so the row
     caps at the container and wraps its buttons rather than overflowing. */
  flex-wrap: wrap;
  max-width: 100%;
}
.page .page-title {
  font-family: var(--display);
  font-weight: 300;
  font-size: 40px;
  line-height: 1.02;
  letter-spacing: -0.03em;
  color: var(--text);
  margin: 6px 0 0;
}
.page-sub {
  font-size: var(--fs-note);
  color: var(--text-secondary);
  margin: 8px 0 0;
  max-width: 70ch;
}
/* Meta band (detail shell): mono label over value, wraps. The nav band
   below it owns the divider rule, so no border here. */
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 32px;
  margin-top: 16px;
}
.meta-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.meta-item__k {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted, #6b7287);
}
.meta-item__v {
  font-size: var(--fs-detail);
  color: var(--text, #0e1428);
}
.meta-item__v--link {
  color: var(--accent, #0c6bf0);
  cursor: pointer;
}
.meta-item__v--link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/ui/PageHead/PageHead.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT;;4DAE0D;EAC1D,eAAe;EACf;gDAC8C;EAC9C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB;2EACyE;EACzE,eAAe;EACf,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;AACA;uDACuD;AACvD;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mEAAmE;EACnE,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/* PageHead — page header (kicker + display title + sub + actions). */\n.page-head {\n  margin-bottom: var(--space-6);\n}\n.page-head__top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n  /* The action row does not shrink, so without wrapping it pushes the page past\n     the viewport on a narrow screen: 370px of buttons against 312px of content\n     area. Wrapping drops the row below the title instead. */\n  flex-wrap: wrap;\n  /* Reserved title-row height so a short title keeps the detail ladder\n     from collapsing (canon: dhead__titlerow). */\n  min-height: 46px;\n}\n.page-head__actions {\n  display: flex;\n  gap: 8px;\n  flex: none;\n  align-items: center;\n  /* Its own line is still narrower than the two buttons side by side, so the row\n     caps at the container and wraps its buttons rather than overflowing. */\n  flex-wrap: wrap;\n  max-width: 100%;\n}\n.page .page-title {\n  font-family: var(--display);\n  font-weight: 300;\n  font-size: 40px;\n  line-height: 1.02;\n  letter-spacing: -0.03em;\n  color: var(--text);\n  margin: 6px 0 0;\n}\n.page-sub {\n  font-size: var(--fs-note);\n  color: var(--text-secondary);\n  margin: 8px 0 0;\n  max-width: 70ch;\n}\n/* Meta band (detail shell): mono label over value, wraps. The nav band\n   below it owns the divider rule, so no border here. */\n.meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 32px;\n  margin-top: 16px;\n}\n.meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.meta-item__k {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted, #6b7287);\n}\n.meta-item__v {\n  font-size: var(--fs-detail);\n  color: var(--text, #0e1428);\n}\n.meta-item__v--link {\n  color: var(--accent, #0c6bf0);\n  cursor: pointer;\n}\n.meta-item__v--link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
